import { useLayoutEffect } from 'react';

// The green colour theme (see the tokens in index.css), used by the landing
// page, the shop listing (products, category results), About us and the FAQ. Set on <html>
// rather than on a page wrapper so portals — modals, the cart drawer, the
// status-bar tint — are themed too. Layout effect, so the first paint is
// already green; removed again when leaving the page.
//
// Between two themed pages React runs the old page's cleanup before the new
// page's effect in the same commit, so the theme stays on without a flash.
const THEME_COLOR = '#378538'; // matches --banner for the green theme

export function useLandingTheme() {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const meta = document.querySelector('meta[name="theme-color"]');
    const previousColor = meta?.getAttribute('content');
    html.dataset.theme = 'landing';
    meta?.setAttribute('content', THEME_COLOR);
    return () => {
      delete html.dataset.theme;
      if (meta && previousColor) meta.setAttribute('content', previousColor);
    };
  }, []);
}
